module.exports = __webpack_public_path__ + "static/media/10-lucazini-hovercolor.b14b05c6.jpg";